import { ReactElement, useEffect } from 'react';

import { Map } from '../map/Map';
import { ClinicList } from '../map/Map.ClinicList';
import { MapSidebar } from '../map/Map.Sidebar';
import { useLocatorStore } from '../store/useLocatorStore';
const BASE_URL = import.meta.env.VITE_BASE_URL;

type Props = {
  mapRef: any;
};

export function MapPage({ mapRef }: Props): ReactElement {
  const activeClinic = useLocatorStore((state) => state.activeClinic);

  const listType = useLocatorStore((state) => state.listType);

  const sidebarOpen = useLocatorStore((state) => state.sidebarOpen);
  const setSidebarOpen = useLocatorStore((state) => state.setSidebarOpen);

  useEffect(() => {
    if (activeClinic) {
      const activeClinicCardEl = document.getElementById(activeClinic.API_Id__c);
      const sidebarMap = document.getElementById('map-sidebar');
      const sidebarMapHeight = sidebarMap?.clientHeight ? (sidebarMap.clientHeight - 88) / 2 : 0;
      const scrollDiff = activeClinicCardEl?.offsetTop
        ? +activeClinicCardEl.offsetTop - sidebarMapHeight
        : 0;

      sidebarMap?.scrollTo({
        top: scrollDiff,
        behavior: 'smooth',
      });
    }
  }, [activeClinic]);

  const gridColumnClasses = sidebarOpen
    ? 'md:grid-cols-[minmax(424px,1fr)_2fr]'
    : 'md:grid-cols-[0_1fr]';

  return (
    <div
      className={`flex flex-col md:grid  md:grid-rows-[100vh] overflow-x-hidden ${gridColumnClasses}`}
    >
      <MapSidebar mapRef={mapRef} />

      <div className={`relative ${listType === 'list' && 'h-0'}`}>
        <img
          src={`${BASE_URL}/assets/images/icons/left-arrow.svg`}
          className={`absolute top-1/2 z-10 tw-hidden h-[56px] w-[32px] -translate-y-1/2 transform cursor-pointer md:flex rtl:rotate-180 ${
            !sidebarOpen && 'rotate-180 rtl:rotate-0'
          }`}
          onClick={() => setSidebarOpen(!sidebarOpen)}
        />
        <Map mapRef={mapRef} className={`${listType === 'list' && 'absolute translate-x-full'}`} />
      </div>

      <div className="md:tw-hidden bg-white">
        <ClinicList />
      </div>
    </div>
  );
}
